<template>
  <div class="alignment">
    <template>
      <v-layout row wrap>
        <v-flex xs6 class="text-xs-left"
          ><h3 class="styleHeader">
            {{ $t("pages.Customer.Index.Committente") }}
          </h3></v-flex
        >
        <v-flex>
          <router-link :to="$i18nRoute({ name: 'CustomerCreate' })">
            <v-btn
              class="right white--text styleHeader styleAlignamentAddButton"
              color="#279947"
            >
              <v-icon left>add</v-icon>
              {{ $t("pages.Customer.Index.Aggiungi") }}
            </v-btn>
          </router-link>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="[
          {
            text: this.currentLanguage.t('pages.Customer.Index.Nome'),
            value: 'name'
          },
          {
            text: this.currentLanguage.t('pages.Customer.Index.Sito'),
            value: 'stockName'
          },
          {
            text: this.currentLanguage.t('pages.Customer.Index.CodiceSocieta'),
            value: 'codiceSocieta'
          },
          {
            text: this.currentLanguage.t(
              'pages.Customer.Index.CodiceGestionale'
            ),
            value: 'codiceAS'
          },
          { text: '' }
        ]"
        :items="customers"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.stockName }}</td>
          <td>{{ props.item.codiceSocieta }}</td>
          <td>{{ props.item.codiceAS }}</td>
          <td>
            <v-btn flat icon class="right" @click="editItem(props.item)">
              <v-icon>edit</v-icon></v-btn
            >
          </td>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import customerApi from "../../apiSmartLogistics/customersApi";
//import router from "../../router/routes.js";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  data() {
    return {
      customers: []
    };
  },
  methods: {
    editItem(item) {
      router.push({ name: "CustomerCreate", params: { id: item.id } });
    }
  },
  computed: {
    currentLanguage() {
      return Trans.i18n;
    }
  },
  created() {
    customerApi.GetCustomers().then(response => {
      this.customers = response.data;
    });
  }
};
</script>
